import React from "react";
import { Link } from "react-router-dom";
import { Plus, Phone, MessageCircle, Mail, MapPin, Clock } from "lucide-react";
import { contact, navLinks, popularCountries } from "../mock";

const FloatingWhatsApp = () => (
  <a
    href={contact.whatsapp}
    target="_blank"
    rel="noreferrer"
    aria-label="Chat on WhatsApp"
    className="fixed bottom-6 right-6 z-50 w-14 h-14 rounded-full bg-green-500 hover:bg-green-600 text-white flex items-center justify-center shadow-lg hover:scale-105 transition-transform"
  >
    <MessageCircle className="w-7 h-7" />
    <span className="absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-60 animate-ping" />
  </a>
);

export default function Footer() {
  return (
    <>
      <footer className="bg-slate-900 text-slate-300">
        <div className="max-w-7xl mx-auto px-4 py-14 grid gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="flex items-center justify-center w-10 h-10 rounded-lg bg-gradient-to-br from-teal-500 to-blue-600 text-white">
                <Plus className="w-6 h-6" strokeWidth={3} />
              </div>
              <div className="leading-none">
                <div className="text-xl font-extrabold text-white">ShipMeds</div>
                <div className="text-[10px] font-semibold tracking-[0.2em] text-slate-400 uppercase">International Services</div>
              </div>
            </div>
            <p className="text-sm text-slate-400 leading-relaxed">
              The trusted international medicine courier service for sending all types of medicines abroad with guaranteed doorstep delivery.
            </p>
          </div>

          <div>
            <h4 className="text-white font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2.5 text-sm">
              {navLinks.map((l) => (
                <li key={l.label}>
                  <Link to={l.to} className="hover:text-teal-400 transition-colors">{l.label}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-white font-semibold mb-4">Popular Destinations</h4>
            <ul className="space-y-2.5 text-sm">
              {popularCountries.slice(0, 7).map((c) => (
                <li key={c.slug}><Link to={`/country/${c.slug}`} className="hover:text-teal-400 transition-colors">{c.name}</Link></li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-white font-semibold mb-4">Get In Touch</h4>
            <ul className="space-y-3 text-sm">
              <li className="flex items-center gap-3"><Phone className="w-4 h-4 text-teal-400 shrink-0" /><a href={`tel:${contact.phoneRaw}`} className="hover:text-teal-400">{contact.phone}</a></li>
              <li className="flex items-center gap-3"><MessageCircle className="w-4 h-4 text-teal-400 shrink-0" /><a href={contact.whatsapp} target="_blank" rel="noreferrer" className="hover:text-teal-400">WhatsApp Support</a></li>
              <li className="flex items-center gap-3"><Mail className="w-4 h-4 text-teal-400 shrink-0" /><a href={`mailto:${contact.email}`} className="hover:text-teal-400">{contact.email}</a></li>
              <li className="flex items-center gap-3"><Clock className="w-4 h-4 text-teal-400 shrink-0" />Working Hours: {contact.hours}</li>
              <li className="flex items-start gap-3"><MapPin className="w-4 h-4 text-teal-400 shrink-0 mt-0.5" />New Delhi, India</li>
            </ul>
          </div>
        </div>
        <div className="border-t border-slate-800">
          <div className="max-w-7xl mx-auto px-4 py-5 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-slate-500">
            <p>© {new Date().getFullYear()} ShipMeds. All rights reserved.</p>
            <div className="flex items-center gap-5">
              <a href="#" className="hover:text-teal-400">Privacy Policy</a>
              <a href="#" className="hover:text-teal-400">Terms &amp; Conditions</a>
            </div>
          </div>
        </div>
      </footer>
      <FloatingWhatsApp />
    </>
  );
}
